
import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FinancialYear } from "../CommonDDL/FinancialYear/FinancialYear";
import { MonthDDL } from "../CommonDDL/Month/MonthDDL";
import { useAuthState } from "../../helper/Context/context";
import { logout } from "../../helper/Context/action";
export const AdminHeader = (props) => {

	const { toggle, isopen, } = props
	const dispatch = useDispatch();
	const userDetails = useAuthState();
	const { UserID, token, year, setYear, Month, setMonth } = userDetails.user

	const [FinancialYearID, setFinancialYearID] = useState({
		DDL: [],
		ID: 0,
		Label: "Year...",
	})

	const [MonthID, setMonthID] = useState({
		DDL: [],
		ID: 0,
		Label: "Month...",
	})

	const [sticky, setSticky] = useState(false)
	const navigation = useNavigate()

	function toggleuser() {
		let side = document.getElementById("userdata")
		side.classList.toggle("hidden1")
		side.classList.toggle("visible")

	}

	const Logout = () => {
		logout(dispatch);
		navigation('/')
		sessionStorage.clear()
	}

	const Navigate = useNavigate()

	return (
		<div className="wrapper mx-0  mb-5 row w-100  px-0" >

			<nav className="mt-3 ms-lg-3 mx-lg-5 navbar fixed-tops d-lg-flex header dark-shadow border-gray pt-3 pb-5 py-lg-0"
				style={{ width: isopen ? "" : "calc(100% - 37px)", marginLeft: isopen ? "" : "14px", marginTop: sticky ? "14px" : "", }} >

				<div className=" mx-0 row navbar-menu-wrapper  d-flex align-items-center justify-content-start mb-4 mb-lg-0" >

					{/* <button
							onClick={toggle}
							className=" navbar-toggler align-self-center hamber pe-lg-3 pe-xl-0"
							type="button"
							data-toggle="minimize"
						>
							<span className="icon-menu"></span>
						</button> */}

					<div className="nav_swaraj_slogon  ps-3 col-lg-7 ">
						<div className="row">
							<div className="col-3 col-lg-2 float-end">
								<img
									src="/Static/Assets/Img/logo.png"
									className="logo float-end cursor-pointer" width={70}
									alt="logo"
									onClick={() => Navigate('/MainDashboard')}
								/>
							</div>
							<div className="col-9 col-lg-10 d-flex align-items-center">

								<h5 className="text-white pt-1 fw-bold">
									Marine Insurance Learning and Sharing Online</h5>

							</div>
						</div>

					</div>

					<div className="col-12 col-md-6 col-lg-4 d-flex align-items-center justify-content-end ps-xl-5 ps-3">
						<div className="row mt-2 mt-lg-0">
							<ul className="navbar-nav navbar-nav-right">
								<div className="row noWrap">
									<>
										<div className="col-5 col-lg-6">
											<FinancialYear
												FinancialYearID={FinancialYearID}
												setFinancialYearID={setFinancialYearID}
											/>
										</div>

										<div className="col-5 col-lg-6 ">
											<MonthDDL
												MonthID={MonthID}
												setMonthID={setMonthID}
											/>
										</div>

										<div className="col-1 col-lg-3 " >
											<li className="nav-item nav-profile dropdown">
												<a
													onClick={toggleuser}
													className="nav-link dropdown-toggle me-4"
													href="#"
													data-toggle="dropdown"
													id="profileDropdown"
												>
													<img src="/Static/Assets/Img/man.png" className="" alt="profile" />

													<i
														className="align-self-center ml-1"
													>
													</i>
												</a>
												<div id="userdata"
													className="dropdown-menu dropdown-menu-right navbar-dropdown"
													aria-labelledby="profileDropdown"
												>
													<Link onClick={() => Logout()} className="dropdown-item">

														<div className="drop_item_two my-1">
															Logout
														</div>
													</Link>
												</div>
											</li>

										</div>

									</>
								</div>


							</ul>
						</div>
					</div>
				</div>

			</nav>

		</div>
	);
}
